module.exports = __webpack_public_path__ + "img/Legetøj-og-Børneprodukter.b1ac637a.jpg";